import { name, vat, email, phone } from "./validations";

export const CompanyValidate = {
  name,
  vat,
  contact_mail: email,
  contact_phone: phone,
};
